import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import '../../styles/MenuGrid.css';
import dietaryIcons from '../../constants/dietaryIcons';

/**
 * Shared food-item detail popup.
 *
 * `food` shape: { name, allergens: string[], station, timePeriods: string[] }
 * Renders nothing if `food` is falsy.
 */
function FoodDetailModal({ food, onClose }) {
  const [hoveredRestriction, setHoveredRestriction] = useState(null);

  if (!food) return null;

  const handleCloseModal = (e) => {
    if (e.target === e.currentTarget) onClose();
  };

  return ReactDOM.createPortal(
    <div
      className="menu-grid-modal-background open"
      onClick={handleCloseModal}
    >
      <div className="menu-grid-modal-content open">
        <button
          className="menu-grid-modal-button"
          onClick={onClose}
          aria-label="Close modal"
        >
          &times;
        </button>
        <div className="modal-header">
          <h2 className="modal-title">{food.name}</h2>
        </div>

        <div className="modal-body">
          {food.description && (
            <p className="modal-description">{food.description}</p>
          )}
          {food.ingredients && (
            <p className="modal-ingredients">{food.ingredients}</p>
          )}
          {food.allergens && food.allergens.length > 0 && (
            <div className="modal-allergens">
              <strong>Dietary Info:</strong>
              <div className="allergen-tags-modal">
                {food.allergens.map(allergen => (
                  <span
                    key={allergen}
                    className="allergen-tag-icon"
                    onMouseEnter={() => setHoveredRestriction(allergen)}
                    onMouseLeave={() => setHoveredRestriction(null)}
                  >
                    <span className="icon-large">{dietaryIcons[allergen] || '🏷️'}</span>
                    {hoveredRestriction === allergen && (
                      <span className="icon-tooltip">{allergen}</span>
                    )}
                  </span>
                ))}
              </div>
            </div>
          )}
        </div>
        <div className="modal-footer">
          <div className="modal-station">
            <span className="footer-label">Station</span>
            <span className="footer-value">{food.station}</span>
          </div>
          <div className="modal-time">
            <span className="footer-label">Available</span>
            <span className="footer-value">{(food.timePeriods || []).join(', ')}</span>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
}

export default FoodDetailModal;